import ApiClient from '../api';

const findPetsByLatLong = (latitude, longitude, radiusInMiles) => {
    const urlPath = "/api/Pet/FindPetsByLatLong?Longitude=" + longitude + "&Latitude=" + latitude + "&RadiusInMiles=" + radiusInMiles;
    var response = ApiClient.get(urlPath);
    return response;
};

const PetApi = { findPetsByLatLong };
export default PetApi;